export const getDefaultData = () => [
  {
    semester: 1,
    number_of_sessions: {  },
  },
  {
    semester: 2,
    number_of_sessions: {  },
  },
  {
    semester: 3,
    number_of_sessions: {  },
  },
];
